import { createApp } from "vue";
import App from "./App.vue";

import router from '@/router/router';

import PrimeVue from 'primevue/config';
import { createI18n } from "vue-i18n";

import Button from "primevue/button";
import Card from "primevue/card";
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import Divider from "primevue/divider";
import MultiSelect from "primevue/multiselect";
import Timeline from "primevue/timeline";

import 'primeicons/primeicons.css';
import "./css/title.css";

import DE from '@/i18n/primevue/de.json';
import EN from '@/i18n/primevue//en.json';
import IT from '@/i18n/primevue//it.json';
import Badge from "primevue/badge";
import ToggleSwitch from "primevue/toggleswitch";

import { createPinia } from 'pinia';
import piniaPersistedstate from 'pinia-plugin-persistedstate';
import Accordion from "primevue/accordion";
import ButtonGroup from "primevue/buttongroup";
import DatePicker from "primevue/datepicker";
import Dialog from "primevue/dialog";
import InputOtp from "primevue/inputotp";
import InputText from "primevue/inputtext";
import Menu from "primevue/menu";
import Password from "primevue/password";
import ToastService from 'primevue/toastservice';
import ToggleButton from "primevue/togglebutton";
import AccordionHeader from "primevue/accordionheader";
import AccordionPanel from "primevue/accordionpanel";
import AccordionContent from "primevue/accordioncontent";
import Select from "primevue/select";
import Textarea from "primevue/textarea";
import FloatLabel from "primevue/floatlabel";
import Chart from "primevue/chart";
import InputNumber from "primevue/inputnumber";
import RadioButton from "primevue/radiobutton";
import Tooltip from "primevue/tooltip";
import Message from "primevue/message";
import Image from "primevue/image";
import SelectButton from "primevue/selectbutton";
import FocusTrap from "primevue/focustrap";
import Checkbox from "primevue/checkbox";
import Drawer from "primevue/drawer";
import ConfirmationService from 'primevue/confirmationservice'
import ConfirmDialog from "primevue/confirmdialog";
import '@/css/style.css';
import '@/css/mobile.css';
import '@/css/tablet.css';
import Aura from '@primeuix/themes/aura';
import { h } from 'vue';
import BadgeDirective from "primevue/badgedirective";
import Ripple from "primevue/ripple";
import StyleClass from "primevue/styleclass";
import SpeedDial from "primevue/speeddial";
import Skeleton from "primevue/skeleton";


const i18n = createI18n({
    legacy: true,
    locale: 'EN',
    fallbackLocale: 'EN',
    messages: {EN,DE,IT,}
  });

const pinia = createPinia();
pinia.use(piniaPersistedstate)




createApp({
    render: () => h(App)
})
    .use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            prefix: 'p',
            darkModeSelector: '.application',
            cssLayer: true,
        }
    },
    ripple: true,
    locale: {
        selectionMessage: "Select columns"
    }
})
.use(router)
.use(pinia)
.use(ToastService)
.use(ConfirmationService)
.use(i18n)
.directive('tooltip', Tooltip)
.directive('badge', BadgeDirective)
.directive('ripple', Ripple)
.directive('styleclass', StyleClass)
.directive('focustrap', FocusTrap)
.component("ToggleButton", ToggleButton)
.component("ToggleSwitch", ToggleSwitch)
.component("MultiSelect", MultiSelect)
.component("DataTable", DataTable)
.component("Column", Column)
.component("Timeline", Timeline)
.component("Divider", Divider)
.component("Button", Button)
.component("Dialog", Dialog)
.component("Badge", Badge)
.component("Card", Card)
.component("InputOtp", InputOtp)
.component("DatePicker", DatePicker)
.component("InputText", InputText)
.component("FloatLabel", FloatLabel)
.component("Password", Password)
.component("SpeedDial", SpeedDial)
.component("Menu", Menu)
.component("ButtonGroup", ButtonGroup)
.component("Accordion", Accordion)
.component("AccordionHeader", AccordionHeader)
.component("AccordionPanel", AccordionPanel)
.component("AccordionContent", AccordionContent)
.component("Select", Select)
.component("Textarea", Textarea)
.component("Chart", Chart)
.component("InputNumber", InputNumber)
.component("RadioButton", RadioButton)
.component("Message", Message)
.component("Image", Image)
.component("SelectButton", SelectButton)
.component("Checkbox", Checkbox)
.component("Drawer", Drawer)
.component("TextArea", Textarea)
.component("Skeleton", Skeleton)
.component("ConfirmDialog", ConfirmDialog)
.mount('#app');